import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"

export function ImageLightbox({ src, onClose }) {
  if (!src) return null
  return (
    <Box data-chat-overlay="true" onClick={onClose} sx={{ position: "fixed", inset: 0, zIndex: 2000,
      backgroundColor: "rgba(var(--app-shadow-rgb),0.85)", display: "flex", alignItems: "center",
      justifyContent: "center", cursor: "zoom-out" }}>
      <Box component="img" src={src}
        sx={{ maxWidth: "90vw", maxHeight: "90vh", borderRadius: 2, boxShadow: "0 0 40px rgba(var(--app-shadow-rgb),0.8)" }} />
      <IconButton onClick={onClose} size="small"
        sx={{ position: "absolute", top: 16, right: 16, color: "rgba(var(--app-fg-rgb),0.7)",
          backgroundColor: "rgba(var(--app-shadow-rgb),0.5)", "&:hover": { color: "#fff" } }}>
        <CloseIcon />
      </IconButton>
    </Box>
  )
}
